import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=69f9c5d2"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=69f9c5d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports